import {createClient} from '@gamezop/auth/client'

export const client = createClient()
